<template>
  <v-app id="login" class="primary">
    <v-main>
      <v-container fill-height fluid>
        <v-row justify="center">
          <v-col cols="4">
            <v-card>
              <v-card-text class="pb-0">
                <v-form v-model="login.valid">
                  <v-text-field
                      v-model="model.username"
                      :rules="[ v => !!v || 'Обязательное поле' ]"
                      prepend-inner-icon="person"
                      class="mb-4"
                      label="Логин"
                      name="login"
                      hide-details
                      solo
                  />
                  <v-text-field
                      :rules="[ v => !!v || 'Обязательное поле' ]"
                      :append-icon="visible ? 'visibility_off' : 'visibility'"
                      :type="visible ? 'text' : 'password'"
                      @click:append="visible = !visible"
                      prepend-inner-icon="lock"
                      v-model="model.password"
                      class="mb-4"
                      label="Пароль"
                      name="password"
                      hide-details
                      solo
                  />
                  <v-alert v-if="login.message"
                           dismissible
                           @input="login.message = ''"
                           class="mt-0"
                           color="error"
                           text>
                    {{ login.message }}
                  </v-alert>
                </v-form>
              </v-card-text>
              <v-card-actions class="px-4 pb-4 pt-0">
                <v-btn :disabled="!login.valid" :loading="login.loading" block color="primary" @click="performLogin">
                  Войти
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    valid: false,
    visible: false,
    model: {
      username: '',
      password: ''
    },
    login: {
      loading: false,
      message: '',
      valid: false,
    },
  }),

  methods: {
    performLogin() {
      if (this.login.valid) {
        this.login.loading = true;
        this.$store
            .dispatch('login', this.model)
            .then(() => this.$router.push('/'), err => this.login.message = err)
            .finally(() => this.login.loading = false);
      }
    },
  },
}
</script>
